import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var TakeaPicture = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 30.997c5.4 0 9.778-4.377 9.778-9.775 0-5.399-4.378-9.775-9.778-9.775s-9.778 4.376-9.778 9.775c0 5.398 4.378 9.775 9.778 9.775Zm0-2.095a7.681 7.681 0 1 0 0-15.36 7.681 7.681 0 1 0 0 15.36Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M34.571 12.843v1.396c0 .772.626 1.397 1.397 1.397h1.397c.771 0 1.397-.625 1.397-1.396v-1.397c0-.771-.626-1.396-1.397-1.396h-1.397c-.771 0-1.397.625-1.397 1.396Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 11.447A5.237 5.237 0 0 1 5.238 6.21h33.524A5.237 5.237 0 0 1 44 11.447v20.946a5.237 5.237 0 0 1-5.238 5.237H5.238A5.237 5.237 0 0 1 0 32.393V11.447Zm5.238-3.142a3.142 3.142 0 0 0-3.143 3.142v20.946a3.142 3.142 0 0 0 3.143 3.142h33.524a3.142 3.142 0 0 0 3.143-3.142V11.447a3.142 3.142 0 0 0-3.143-3.142H5.238Z"
  }));
});
TakeaPicture.displayName = 'TakeaPicture';
TakeaPicture.defaultProps = {
  'aria-label': 'TakeaPicture'
};
export default TakeaPicture;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/TakeAPicture.js
// module id = 3931
// module chunks = 11